import Mutations from '../../odata/mutations';

export default { ...new Mutations('deliveryAddress'), ...new Mutations('deliveryAddresses') };
